import { api } from './postMessage.js';

function handler(payload, e) {
  api.turnOn();
}
api.addHandler('turnOn', handler);
